import Container from "@client/content/Containers/container";
import TableView from "@client/content/controls/TableView/container";
import { getContainerProps, getRootContainerProps } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import { Status } from "@client/types";
import { useI18n } from "@common/hooks/i18n";
import * as React from "react";
import { type MemberDownloads } from "./types";

export type MapProps = RootContainerProps & {
  items: MemberDownloads.Item[];
  status: string;
};

export interface ActionProps {}

export default (props: ActionProps & MapProps) => {
  const i18n = useI18n();

  return (
    <Container {...getContainerProps(props)}>
      <TableView
        {...getRootContainerProps(props)}
        idKey="id"
        isLoading={props.status === Status.Loading}
        columns={[
          {
            key: "name",
            name: i18n.name,
            dataType: "string",
            data: (item: MemberDownloads.Item) => (
              <a href={item.fileUrl} target="_blank">
                {item.name}
              </a>
            )
          }
        ]}
        noDataText={i18n.infoNoDownloads}
        data={props.items}
        itemMenu={null}
      />
    </Container>
  );
};
